import { InboxOutlined, PlusOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  Divider,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Space,
  Spin,
  Switch,
  Tag,
  Tooltip,
  Upload,
} from "antd";
import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "../../api/http";
import userServiceApi from "../../api/userServiceApi";
import deleteIcon from "../../assets/images/delete-icon.svg";
import editIcon from "../../assets/images/edit-icon.svg";
import leftArrow from "../../assets/images/LeftArrow.svg";
import "./configuration.scss";
import { inputFieldCharLimit } from "../../config/index";
import { truncate } from "../../utils/helper";

export default function Configurations() {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [form1] = Form.useForm();
  const [form2] = Form.useForm();
  const [form3] = Form.useForm();
  const inputRef = useRef(null);
  const { Dragger } = Upload;
  const partnerId = sessionStorage.getItem("partnerId");
  const partnerName = sessionStorage.getItem("partnerName");
  const [disableSaveTime, setDisabledSaveTime] = useState(true);

  const [sectors, setSectors] = useState([]);
  const [subsectors, setSubSectors] = useState([]);
  const [customName, setCustomName] = useState("");
  const [customNameSubSector, setCustomNameSubSector] = useState("");
  const [selectedSector, setSelectedSector] = useState(null);
  const [selectedSubSector, setSelectedSubSector] = useState(null);
  const [sectorSelectedFlag, setSectorSelectedFlag] = useState(false);

  const [saveDisabled, setSaveDisabled] = useState(true);
  const [listSubSector, setListSubSector] = useState([]);
  const [newOrganisationType, setNewOrganisationType] = useState([]);
  const [newPartnerType, setNewPartnerType] = useState([]);
  const [editID, setEditID] = useState();
  const [partnerEditID, setPartnerEditID] = useState();
  const [organisationTypes, setOrganisationTypes] = useState([]);
  const [organisationTypesAddDisable, setOrganisationTypesAddDisable] =
    useState(true);
  const [partnerTypes, setPartnerTypes] = useState([]);
  const [partnerTypesAddDisable, setPartnerTypesAddDisable] = useState(true);
  const [loading, setLoading] = useState(false);
  const [loadingPartnerType, setLoadingPartnerType] = useState(false);
  const [restoreTime, setRestoreTime] = useState("");


  const validateNumber = (rule, value) => {
    if (isNaN(value)) {
      return Promise.reject("Please enter a valid number.");
    }
    if (value < 1) {
      return Promise.reject("Number must be greater than 0.");
    }
    if (value > 90) {
      toast.error("Number must not be more than 90 days.");
      return Promise.reject("Number must not be more than 90 days.");
    }
    return Promise.resolve();
  };

  const getDeletionThresholdDays = async () => {
    try {
      const { data } = await getRequest(
        userServiceApi.getDeletionThresholdDays(partnerId)
      );
      if (data) {
        form.setFieldValue("deletionThresholdDays", data);
        setRestoreTime(data);
      }
    } catch (error) {
      toast.error(error);
    }
  };

  useEffect(() => {
    if (partnerId) {
      getDeletionThresholdDays();
    }
  }, [partnerId]);

  const onFinishRestoreConfig = async () => {
    try {
      if (restoreTime) {
        const response = await putRequest(
          userServiceApi.updateRestoreTime(partnerId, restoreTime)
        );
        if (response) {
          getDeletionThresholdDays();
          toast.success(
            `Time to restore organisation in ${partnerName} updated`
          );
          setRestoreTime("");
          form.resetFields();
          setDisabledSaveTime(true);
        }
      }
    } catch (error) {
      toast.error(error);
    }
  };

  const handleSectorSelectChange = (sectorSelectedValue) => {
    setSubSectors([]);
    setSectorSelectedFlag(true);
    setSelectedSector(sectorSelectedValue);
    setSaveDisabled(false);
  };


  // const handleSubSectorSelectChange = (subSsectorSelectedValue) => {
  //   setSelectedSubSector(subSsectorSelectedValue);
  // };

  const handleSubSectorSelectChange = (value) => {
    setSelectedSubSector(value);
  };

  const closeSectorModal = () => {
    setSelectedSector(null);
    setCustomName("");
    setSelectedSubSector(null);
    setCustomNameSubSector("");
    setSaveDisabled(true);
    setSectorSelectedFlag(false);
    form3.resetFields();
  };

  useEffect(() => {
    if (isValidUUID(selectedSector)) {
      getAllSubSectors();
    }
  }, [selectedSector]);

  const postsectorSubsector = async () => {
    try {
      if (!isValidUUID(selectedSector) && subsectors) {
        const formattedData = {
          partnerId: partnerId,
          name: selectedSector,
          subSectors: subsectors,
        };
        const response = await postRequest(
          userServiceApi.postsectorSubsector(),
          formattedData
        );
        if (response) {
          toast.success("Category and Sub-category added");
          getAllSectors();
          setTimeout(() => {
            closeSectorModal();
          }, 500)
        }
      } else {
        const formattedData = subsectors.filter((sector) => !sector.id);

        const response = await postRequest(
          userServiceApi.updatesectorSubsector(selectedSector, partnerId),
          formattedData
        );
        if (response) {
          toast.success("Category and Sub-category updated");
          getAllSectors();
          setTimeout(() => {
            closeSectorModal();
          }, 500)
          // closeSectorModal();
        }
      }
    } catch (error) {
      toast.error(error);
    }
  };

  const onNameChange = (e) => setCustomName(e.target.value);
  const onNameChangeSubSector = (e) => setCustomNameSubSector(e.target.value);

  // const addItem = () => {
  //   if (customName && !sectors.includes(customName)) {
  //     setSectors((prevSectors) => [...prevSectors, { name: customName }]);
  //     setCustomName("");
  //     setSaveDisabled(false);
  //   }
  // };

  const addItem = () => {
    if (!customName) return;
    const newCategory = { id: customName, name: customName };
    setSectors((prev) => [...prev, newCategory]);
    setCustomName("");
  };

  // const addItemSubSector = () => {
  //   if (customNameSubSector && !subsectors.includes(customNameSubSector)) {
  //     setSubSectors((prevSectors) => [
  //       ...prevSectors,
  //       { name: customNameSubSector },
  //     ]);
  //     setCustomNameSubSector("");
  //     setSaveDisabled(false);
  //   }
  // };

  const addItemSubSector = () => {
    if (!customNameSubSector) return;
    const newSubCategory = { id: Date.now(), name: customNameSubSector };
    setSubSectors((prev) => [...prev, newSubCategory]);
    setCustomNameSubSector("");
  };

  const deleteSector = async () => {
    try {
      const response = await deleteRequest(
        userServiceApi.deleteSector(selectedSector)
      );
      if (response) {
        toast.success("Selected sector and subsector deleted");
        getAllSectors();
        closeSectorModal();
      }
    } catch (error) {
      toast.error(error);
    }
  };

  const deleteSectorSubSector = async () => {
    try {
      const response = await deleteRequest(
        userServiceApi.deleteSubsector(selectedSubSector)
      );
      if (response) {
        toast.success("Selected subsector deleted");
        getAllSectors();
        closeSectorModal();
      }
    } catch (error) {
      toast.error(error);
    }
  };

  const getAllSectors = async () => {
    try {
      const response = await getRequest(
        userServiceApi.getAllSectors(partnerId)
      );
      if (response) {
        setSectors(response.data);
      }
    } catch (error) {
      toast.error(error);
    }
  };

  const getAllSubSectors = async () => {
    try {
      const response = await getRequest(
        userServiceApi.getAllSubSectors(selectedSector)
      );
      if (response) {
        setSubSectors(response.data);
        setListSubSector((item) => [
          ...item,
          response.data.map((name) => name.name),
        ]);
      }
    } catch (error) {
      toast.error(error);
    }
  };

  useEffect(() => {
    if (partnerId) {
      getAllSectors();
    }
  }, []);

  const isValidUUID = (value) => {
    const uuidRegex =
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
    return uuidRegex.test(value);
  };

  const nameCoresspondingToId = (idToCheck) => {
    const matchingItem = sectors.find((item) => item.id === idToCheck);
    return matchingItem ? matchingItem.name : null;
  };

  useEffect(() => {
    if (isValidUUID(selectedSector)) {
      getAllSubSectors();
    }
  }, [selectedSector]);

  const handleAdd = ({ type }) => {
    if (type && type.trim().length) {
      setNewOrganisationType([...newOrganisationType, type]);
      inputRef.current.value = "";
      inputRef.current.focus();
      form1.resetFields();
      setOrganisationTypesAddDisable(true);
    }
  };

  const handlePartnerAdd = ({ type }) => {
    if (type && type.trim().length) {
      setNewPartnerType([...newPartnerType, type]);
      inputRef.current.value = "";
      inputRef.current.focus();
      form2.resetFields();
      setPartnerTypesAddDisable(true);
    }
  };

  const handlecancelSave = () => {
    setNewOrganisationType([]);
    form1.resetFields();
    setOrganisationTypesAddDisable(true);
  };

  const handlePartnercancelSave = () => {
    setNewPartnerType([]);
    form2.resetFields();
    setPartnerTypesAddDisable(true);
  };

  const handleRemove = (tagToRemove) => {
    setNewOrganisationType(
      newOrganisationType?.filter((tag) => tag !== tagToRemove)
    );
  };

  const handlePartnerRemove = (tagToRemove) => {
    setNewPartnerType(newPartnerType?.filter((tag) => tag !== tagToRemove));
  };

  const handleSave = async () => {
    const moddedArray = newOrganisationType?.map((item) => {
      return {
        displayName: item,
        type: "ORGANIZATION_TYPE",
      };
    });
    try {
      const response = await postRequest(
        userServiceApi.postAddOrganisationOrPartnerType(partnerId),
        moddedArray
      );
      if (response) {
        toast.success("New Organisation types added");
        setNewOrganisationType([]);
        getAllOrganisationTypes();
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handlePartnerSave = async () => {
    const moddedArray = newPartnerType?.map((item) => {
      return {
        displayName: item,
        type: "PARTNER_TYPE",
      };
    });
    try {
      const response = await postRequest(
        userServiceApi.postPartnerType(partnerId),
        moddedArray
      );
      if (response) {
        toast.success("New Partner types added");
        setNewPartnerType([]);
        getAllPartnerTypes();
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getAllOrganisationTypes = async () => {
    try {
      setLoading(true);
      const response = await getRequest(
        userServiceApi.getAllOrganizationTypes(partnerId)
      );
      if (response) {
        setOrganisationTypes(response.data);
        setLoading(false);
      }
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  const getAllPartnerTypes = async () => {
    try {
      setLoadingPartnerType(true);
      const response = await getRequest(
        userServiceApi.getAllPartnerTypes(partnerId)
      );
      if (response) {
        setPartnerTypes(response.data);
        setLoadingPartnerType(false);
      }
    } catch (error) {
      console.error(error);
      setLoadingPartnerType(false);
    }
  };

  useEffect(() => {
    getAllOrganisationTypes();
    getAllPartnerTypes();
  }, []);

  const handleDelete = async (type) => {
    try {
      const response = await deleteRequest(
        userServiceApi.deleteOrganisationType(type.id)
      );
      if (response) {
        getAllOrganisationTypes();
        toast.success(`${type.displayName} deleted successfully`);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handlePartnerDelete = async (type) => {
    try {
      const response = await deleteRequest(
        userServiceApi.deletePartnerType(type.id)
      );
      if (response) {
        getAllPartnerTypes();
        toast.success(`${type.type} deleted successfully`);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleEdit = async (value) => {
    let editObj = {
      id: editID,
      displayName: value.type,
      type: "ORGANIZATION_TYPE",
    };

    try {
      const response = await putRequest(
        userServiceApi.putEditOrganisationOrPartnerType(partnerId),
        editObj
      );
      if (response) {
        setEditID();
        toast.success("Organisation type edited successfully");
        setOrganisationTypes(response);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handlePartnerEdit = async (value) => {
    let editObj = {
      id: partnerEditID,
      displayName: value.type,
      type: "PARTNER_TYPE",
    };

    try {
      const response = await putRequest(
        userServiceApi.putEditOrganisationOrPartnerType(partnerId),
        editObj
      );
      if (response) {
        setPartnerEditID();
        toast.success("Partner type edited successfully");
        setPartnerTypes(response);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleChecker = async (checked, type) => {
    let editObj = {
      ...type,
      toggle: checked,
    };

    try {
      const response = await putRequest(
        userServiceApi.putEditOrganisationOrPartnerType(partnerId),
        editObj
      );
      if (response) {
        setEditID();
        setOrganisationTypes(response);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handlePartnerChecker = async (checked, type) => {
    let editObj = {
      ...type,
      toggle: checked,
    };

    try {
      const response = await putRequest(
        userServiceApi.putEditOrganisationOrPartnerType(partnerId),
        editObj
      );
      if (response) {
        setPartnerEditID();
        setPartnerTypes(response);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const downloadExcelTemplate = async () => {
    try {
      const authToken = sessionStorage.getItem("token");

      const downloadUrl = userServiceApi.downloadExcelTemplate();
      const response = await axios.get(downloadUrl, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
        responseType: "blob",
      });

      if (response) {
        const fileName = "Template.xlsx";
        const blob = new Blob([response.data]);
        const downloadLink = document.createElement("a");
        downloadLink.href = URL.createObjectURL(blob);
        downloadLink.download = fileName;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
    } catch (error) {
      toast.error("Error downloading file");
    }
  };
  const checkFile = (file) => {
    const isExcelFile =
      file.type ===
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
      file.type === "application/vnd.ms-excel";

    if (!isExcelFile) {
      toast.error("You can only upload Excel files (XLSX or XLS)!");
    }
    return isExcelFile;
  };

  const uploadFile = async (formData) => {
    try {
      const res = await postRequest(
        userServiceApi.uploadExcelTemplate(partnerId),
        formData,
      );

      if (res) {
        toast.success("File uploaded successfully");
        getAllSectors();
      }
    } catch (error) {
      console.error(error);

      toast.error(error.error);
    }
  };

  const handleUploadAPI = ({ file }) => {
    var formData = new FormData();
    const blob = new Blob([file], {
      type: "multipart/form-data",
    });
    formData.append("file", blob, file.name);
    uploadFile(formData);
  };

  const uploadProps = {
    accept: ".xls, .xlsx",
    beforeUpload: checkFile,
    maxCount: 1,
    multiple: false,
    showUploadList: false,
    customRequest: handleUploadAPI,
  };

  return (
    <div className="configuration-page">

      <div className="filters-container">
        <div className="partner-heading">
          <div
            className="heading-backBtn"
            onClick={() => {
              navigate("/admin");
              sessionStorage.removeItem("partnerName");
              sessionStorage.removeItem("partnerId");
            }}
          >
            <img src={leftArrow} alt="leftarrow" />
            <p>Configurations {`for ${truncate(partnerName)}` || ""} </p>
          </div>
        </div>
      </div>
      <div className="organisationFormContainer">
        {loading ? (
          <Spin className="data-loader loading-svg" tip="Loading" size="large" />
        ) : (
          <div className="organisation-type">
            <div className="config-heading">Configure organisation type</div>
            <div className="form-component">

              <div className="configureFormRow">
                <div className="configureFormCol">Organisation Type</div>
                <div className="configureFormCol">
                  <div className="configureFieldRow">
                    <div className="configureFieldCol">
                      <Form onFinish={handleAdd} autoComplete="off" form={form1}>
                        <Col className="gutter-row tabContent index-tab" span={16}>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                            }}
                          >
                            <Form.Item
                              name="type"
                              // label="Organisation Type"
                              labelCol={{ span: 7 }}
                              style={{ minWidth: "100%", paddingLeft: "0px" }}
                            >
                              <Input
                                ref={inputRef}
                                className="input-field"
                                placeholder="Enter new organisation type"
                                onChange={() => setOrganisationTypesAddDisable(false)}
                                maxLength={inputFieldCharLimit}
                              />
                            </Form.Item>
                            {organisationTypesAddDisable ? (
                              <Form.Item
                                style={{
                                  marginLeft: "10px",
                                  opacity: "0.5",
                                  cursor: "not-allowed",
                                }}
                              >
                                <Button
                                  className="redBtn add-btn"
                                  style={{ height: "40px" }}
                                >
                                  Add
                                </Button>
                              </Form.Item>
                            ) : (
                              <Form.Item style={{ marginLeft: "10px" }}>
                                <Button
                                  className="redBtn add-btn"
                                  style={{ height: "40px" }}
                                  htmlType="submit"
                                >
                                  Add
                                </Button>
                              </Form.Item>
                            )}
                          </div>
                        </Col>
                      </Form>
                      {newOrganisationType.length > 0 && (
                        <>
                          <div className="new-items">
                            {newOrganisationType?.map((newItem, index) => (
                              <div className="tag" key={newItem}>
                                <Tag
                                  className="tags-component"
                                  closable={true}
                                  onClose={() => handleRemove(newItem)}
                                >
                                  <span
                                    className="ellipsis-tag-content"
                                    title={newItem}
                                  >
                                    {newItem}
                                  </span>
                                </Tag>
                              </div>
                            ))}
                          </div>
                          <div className="btn-container">
                            <Button
                              className="clear-btn"
                              onClick={handlecancelSave}
                            >
                              Cancel
                            </Button>
                            <Button
                              className="redBtn SaveBtn"
                              style={{ marginLeft: "10px" }}
                              onClick={handleSave}
                            >
                              Save
                            </Button>
                          </div>
                          <Divider />
                        </>
                      )}
                    </div>
                  </div>
                  <div className="configureFieldRow">
                    <div className="configureFieldCol">
                      <div className="display">
                        {organisationTypes && organisationTypes.length > 0
                          ? organisationTypes?.map((type) => (
                            <div className="type-item">
                              {type.id === editID ? (
                                <>
                                  <Form
                                    onFinish={handleEdit}
                                    className="item-edit-form"
                                    initialValues={{
                                      type: type.displayName,
                                    }}
                                  >
                                    <div className="inputWithBtn">
                                      <div className="inputWithBtnCol">
                                        <Form.Item name="type">
                                          <Input className="edit-input" />
                                        </Form.Item>
                                      </div>
                                      <div className="inputWithBtnCol">
                                        <div className="inputWithBtnBox">
                                          <Form.Item>
                                            <Button
                                              style={{ marginRight: "5px" }}
                                              className="redBtn SaveBtn"
                                              htmlType="submit"
                                            >
                                              Save
                                            </Button>
                                          </Form.Item>
                                          <Form.Item>
                                            <Button
                                              className="clear-btn"
                                              onClick={() => setEditID()}
                                            >
                                              Cancel
                                            </Button>
                                          </Form.Item>
                                        </div>
                                      </div>
                                    </div>


                                  </Form>
                                </>
                              ) : (
                                <>
                                  <div>{type.displayName}</div>
                                  <div className="op-btns">
                                    <div className="remove-btns">
                                      <img
                                        style={{ marginTop: "2px" }}
                                        src={editIcon}
                                        alt="editIcon"
                                        onClick={() => setEditID(type.id)}
                                      />
                                    </div>
                                    <div className="lineVertical"></div>
                                    {type.isUsed ? (
                                      <>
                                        <Tooltip
                                          title={"Organisation type is in use"}
                                        >
                                          <div
                                            className="remove-btns"
                                            style={{
                                              opacity: "0.5",
                                              cursor: "not-allowed",
                                            }}
                                          >
                                            <img
                                              src={deleteIcon}
                                              alt="deleteIcon"
                                            />
                                          </div>
                                        </Tooltip>
                                        <div className="lineVertical"></div>
                                        <Tooltip
                                          title={"Organisation type is in use"}
                                        >
                                          <Switch
                                            style={{
                                              opacity: "0.5",
                                              cursor: "not-allowed",
                                            }}
                                            disabled
                                            className="orgtype-switch"
                                            defaultChecked={
                                              type.toggle ? true : false
                                            }
                                          />
                                        </Tooltip>
                                      </>
                                    ) : (
                                      <>
                                        <div className="remove-btns">
                                          <img
                                            src={deleteIcon}
                                            alt="deleteIcon"
                                            onClick={() => handleDelete(type)}
                                          />
                                        </div>
                                        <div className="lineVertical"></div>
                                        <Switch
                                          className="orgtype-switch"
                                          defaultChecked={
                                            type.toggle ? true : false
                                          }
                                          onChange={(checked) => {
                                            handleChecker(checked, type);
                                          }}
                                        />
                                      </>
                                    )}
                                  </div>
                                </>
                              )}
                            </div>
                          ))
                          : null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="horizontalLine"></div>

        {loadingPartnerType ? (
          <Spin className="data-loader loading-svg" tip="Loading" size="large" />
        ) : (
          <div className="organisation-type">
            <div className="config-heading">Configure partner type</div>
            <div className="form-component">
              <div className="configureFormRow">
                <div className="configureFormCol">Partner Type</div>
                <div className="configureFormCol">
                  <div className="configureFieldRow">
                    <div className="configureFieldCol">
                      <Form
                        onFinish={handlePartnerAdd}
                        autoComplete="off"
                        form={form2}
                      >
                        <Col className="gutter-row tabContent index-tab" span={16}>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                            }}
                          >
                            <Form.Item
                              name="type"
                              // label="Partner Type"
                              labelCol={{ span: 7 }}
                              style={{ minWidth: "100%", paddingLeft: "0px" }}
                            >
                              <Input
                                ref={inputRef}
                                className="input-field"
                                placeholder="Enter new partner type"
                                onChange={() => setPartnerTypesAddDisable(false)}
                                maxLength={inputFieldCharLimit}
                              />
                            </Form.Item>
                            {partnerTypesAddDisable ? (
                              <Form.Item
                                style={{
                                  marginLeft: "10px",
                                  opacity: "0.5",
                                  cursor: "not-allowed",
                                }}
                              >
                                <Button
                                  className="redBtn add-btn"
                                  style={{ height: "40px" }}
                                >
                                  Add
                                </Button>
                              </Form.Item>
                            ) : (
                              <Form.Item style={{ marginLeft: "10px" }}>
                                <Button
                                  className="redBtn add-btn"
                                  style={{ height: "40px" }}
                                  htmlType="submit"
                                >
                                  Add
                                </Button>
                              </Form.Item>
                            )}
                          </div>
                        </Col>
                      </Form>
                      {newPartnerType.length > 0 && (
                        <>
                          <div className="new-items">
                            {newPartnerType?.map((newItem, index) => (
                              <div className="tag" key={newItem}>
                                <Tag
                                  className="tags-component"
                                  closable={true}
                                  onClose={() => handlePartnerRemove(newItem)}
                                >
                                  <span
                                    className="ellipsis-tag-content"
                                    title={newItem}
                                  >
                                    {newItem}
                                  </span>
                                </Tag>
                              </div>
                            ))}
                          </div>
                          <div className="btn-container">
                            <Button
                              className="clear-btn"
                              onClick={handlePartnercancelSave}
                            >
                              Cancel
                            </Button>
                            <Button
                              className="redBtn SaveBtn"
                              style={{ marginLeft: "10px" }}
                              onClick={handlePartnerSave}
                            >
                              Save
                            </Button>
                          </div>
                          <Divider />
                        </>
                      )}
                    </div>
                  </div>
                  <div className="configureFieldRow">
                    <div className="configureFieldCol">
                      <div className="display">
                        {partnerTypes && partnerTypes.length > 0
                          ? partnerTypes?.map((type) => (
                            <div className="type-item">
                              {type.id === partnerEditID ? (
                                <>
                                  <Form
                                    onFinish={handlePartnerEdit}
                                    className="item-edit-form"
                                    initialValues={{
                                      type: type.displayName,
                                    }}
                                  >
                                    <div className="inputWithBtn">
                                      <div className="inputWithBtnCol">
                                        <Form.Item name="type">
                                          <Input className="edit-input" />
                                        </Form.Item>
                                      </div>
                                      <div className="inputWithBtnCol">
                                        <div className="inputWithBtnBox">


                                          <Form.Item>
                                            <Button
                                              style={{ marginRight: "5px" }}
                                              className="redBtn SaveBtn"
                                              htmlType="submit"
                                            >
                                              Save
                                            </Button>
                                          </Form.Item>
                                          <Form.Item>
                                            <Button
                                              className="clear-btn"
                                              onClick={() => setPartnerEditID()}
                                            >
                                              Cancel
                                            </Button>
                                          </Form.Item>
                                        </div>
                                      </div>
                                    </div>
                                  </Form>
                                </>
                              ) : (
                                <>
                                  <div>{type.displayName}</div>
                                  <div className="op-btns">
                                    <div className="remove-btns">
                                      <img
                                        style={{ marginTop: "2px" }}
                                        src={editIcon}
                                        alt="editIcon"
                                        onClick={() => setPartnerEditID(type.id)}
                                      />
                                    </div>
                                    <div className="lineVertical"></div>
                                    {type.isUsed ? (
                                      <>
                                        <Tooltip title={"Partner type is in use"}>
                                          <div
                                            className="remove-btns"
                                            style={{
                                              opacity: "0.5",
                                              cursor: "not-allowed",
                                            }}
                                          >
                                            <img
                                              src={deleteIcon}
                                              alt="deleteIcon"
                                            />
                                          </div>
                                        </Tooltip>
                                        <div className="lineVertical"></div>
                                        <Tooltip title={"Partner type is in use"}>
                                          <Switch
                                            style={{
                                              opacity: "0.5",
                                              cursor: "not-allowed",
                                            }}
                                            disabled
                                            className="orgtype-switch"
                                            defaultChecked={
                                              type.toggle ? true : false
                                            }
                                          />
                                        </Tooltip>
                                      </>
                                    ) : (
                                      <>
                                        <div className="remove-btns">
                                          <img
                                            src={deleteIcon}
                                            alt="deleteIcon"
                                            onClick={() =>
                                              handlePartnerDelete(type)
                                            }
                                          />
                                        </div>
                                        <div className="lineVertical"></div>
                                        <Switch
                                          className="orgtype-switch"
                                          defaultChecked={
                                            type.toggle ? true : false
                                          }
                                          onChange={(checked) => {
                                            handlePartnerChecker(checked, type);
                                          }}
                                        />
                                      </>
                                    )}
                                  </div>
                                </>
                              )}
                            </div>
                          ))
                          : null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Row
                className="rowBody h-25"
                gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
              >

              </Row>
            </div>
          </div>
        )}

        <div className="horizontalLine"></div>
        <div className="sector-subsector">
          <div className="config-heading">
            <h3>Configure categories and Sub categories</h3>
          </div>
          <div className="form-component">

            <div className="configureFormRow">
              <div className="configureFormCol">Categories Type</div>
              <div className="configureFormCol">
                <div className="configureFieldRow">
                  <div className="configureFieldCol">
                    <Form form={form3} style={{ width: "100%" }}>
                      <div className="ms-edit-main-sector">
                        <Form.Item
                          labelCol={{ span: 6 }}
                          name="sector"
                        // label="Categories"
                        >
                          <div className="select-div">
                            <Select
                              value={selectedSector}
                              onChange={(e) => handleSectorSelectChange(e)}
                              placeholder="view and add Categories"
                              dropdownRender={(menu) => (
                                <>
                                  {menu}
                                  <Divider
                                    style={{
                                      margin: "8px 0",
                                    }}
                                  />
                                  <Space
                                    style={{
                                      padding: "0 8px 4px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "row",
                                      }}
                                    >
                                      <Input
                                        placeholder="Please enter Categories"
                                        value={customName}
                                        onChange={onNameChange}
                                      />
                                      <Button
                                        type="text"
                                        icon={<PlusOutlined />}
                                        onClick={addItem}
                                      >
                                        Add Categories
                                      </Button>
                                    </div>
                                  </Space>
                                </>
                              )}
                              options={sectors?.map((item) => {
                                return {
                                  label: item.name,
                                  value: item.id || item.name,
                                };
                              })}
                            ></Select>
                            {selectedSector ? (
                              <img
                                src={deleteIcon}
                                alt="deleteIcon"
                                style={{ marginLeft: "5px" }}
                                onClick={deleteSector}
                              />
                            ) : null}
                          </div>
                        </Form.Item>
                        <Form.Item
                          labelCol={{ span: 6 }}
                          name="subSector"
                        // label="Sub categories"
                        >
                          {sectorSelectedFlag ? (
                            <div className="select-div">
                              <Select
                                value={selectedSubSector}
                                onChange={(e) => handleSubSectorSelectChange(e)}
                                placeholder="view and add Sub categories"
                                dropdownRender={(menu) => (
                                  <>
                                    {menu}
                                    <Divider
                                      style={{
                                        margin: "8px 0",
                                      }}
                                    />
                                    <Space
                                      style={{
                                        padding: "0 8px 4px",
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: "flex",
                                          flexDirection: "row",
                                        }}
                                      >
                                        <Input
                                          placeholder="Please enter Sub categories"
                                          value={customNameSubSector}
                                          onChange={onNameChangeSubSector}
                                        />
                                        <Button
                                          type="text"
                                          icon={<PlusOutlined />}
                                          onClick={addItemSubSector}
                                        >
                                          Add Sub categories
                                        </Button>
                                      </div>
                                    </Space>
                                  </>
                                )}
                                options={subsectors?.map((item) => ({
                                  label: item.name,
                                  value: item.id,
                                }))}
                              ></Select>
                              {selectedSubSector ? (
                                <img
                                  src={deleteIcon}
                                  alt="deleteIcon"
                                  style={{ marginLeft: "5px" }}
                                  onClick={deleteSectorSubSector}
                                />
                              ) : null}
                            </div>
                          ) : (
                            <Select
                              disabled
                              value={selectedSubSector}
                              onChange={(e) => handleSubSectorSelectChange(e)}
                              placeholder="view and add Sub categories"
                              dropdownRender={(menu) => (
                                <>
                                  {menu}
                                  <Divider
                                    style={{
                                      margin: "8px 0",
                                    }}
                                  />
                                  <Space
                                    style={{
                                      padding: "0 8px 4px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "row",
                                      }}
                                    >
                                      <Input
                                        placeholder="Please enter Categories"
                                        value={customNameSubSector}
                                        onChange={onNameChangeSubSector}
                                      />
                                      <Button
                                        type="text"
                                        icon={<PlusOutlined />}
                                        onClick={addItemSubSector}
                                      >
                                        Add Sub categories
                                      </Button>
                                    </div>
                                  </Space>
                                </>
                              )}
                              options={subsectors?.map((item) => ({
                                label: item.name,
                                value: item.id,
                              }))}
                            ></Select>
                          )}
                        </Form.Item>
                      </div>
                    </Form>
                  </div>
                </div>
                <div className="configureFieldRow">
                  <div className="configureFieldCol">
                    <div className="form-btn-container">
                      <Button
                        onClick={closeSectorModal}
                        className="clear-btn"
                        style={{ marginRight: "10px" }}
                      >
                        Cancel{" "}
                      </Button>
                      {saveDisabled ? (
                        <Button
                          className="saveBtn redBtn"
                          style={{ opacity: "0.5", cursor: "not-allowed" }}
                        >
                          Submit{" "}
                        </Button>
                      ) : (
                        <Button className="saveBtn redBtn" onClick={postsectorSubsector}>
                          Submit{" "}
                        </Button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div
            className="dividing-line"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Divider
              className="sector-divider"
              style={{
                borderTop: "2px solid #A5A5A5",
                minWidth: "40%",
                width: "40%",
              }}
            />
            <p>Or</p>
            <Divider
              className="sector-divider"
              style={{
                borderTop: "2px solid #A5A5A5",
                minWidth: "40%",
                width: "40%",
              }}
            />
          </div>
          <div className="bulk-upload-component">
            <div className="config-heading bulk-header">
              Bulk upload categories and Sub categories
            </div>
            <div className="">
              <div className="configureFormRow">
                <div className="configureFormCol">Upload excel template file</div>
                <div className="configureFormCol">
                  <div className="configureFieldRow">
                    <div className="configureFieldCol">
                      <Dragger {...uploadProps} className="dropbox">
                        <div className="box-content">
                          <p className="ant-upload-drag-icon">
                            <InboxOutlined />
                          </p>
                          <p className="ant-upload-text">
                            Click or drag file to this area to upload
                          </p>
                        </div>
                      </Dragger>
                    </div>
                  </div>
                  <div className="configureFieldRow">
                    <div className="configureFieldCol">
                      <div className="form-btn-container">
                        <Button
                          className="saveBtn redBtn"
                          style={{ height: "40px", margin: '20px 0 0' }}
                          onClick={() => downloadExcelTemplate()}
                        >
                          Download template
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div className="horizontalLine"></div>
        <div className="restore-time">
          <div className="config-heading">Configure restore time</div>
          <div className="form-component">
            <div className="configureFormRow">
              <div className="configureFormCol">Time to restore organisation</div>
              <div className="configureFormCol">
                <div className="configureFieldRow">
                  <div className="configureFieldCol">
                    <Form
                      onFinish={onFinishRestoreConfig}
                      autoComplete="off"
                      form={form}
                    >
                      <Form.Item
                        rules={[
                          {
                            required: true,
                            message: "Please input the number of days.",
                          },
                          {
                            type: "number",
                            message: "Please input a valid number.",
                          },
                          { validator: validateNumber },
                        ]}
                        style={{ minWidth: "100%" }}
                        labelCol={{ span: 7 }}
                        // label="Time to restore organisation"
                        name="deletionThresholdDays"
                        value={restoreTime}
                      >
                        <InputNumber
                          min={1}
                          max={90}
                          style={{
                            width: "100%",
                            height: "40px",
                          }}
                          placeholder="Enter Days to restore organisation"
                          onChange={(e) => {
                            setDisabledSaveTime(false);
                            setRestoreTime(e);
                          }}
                        />
                      </Form.Item>
                    </Form>
                  </div>
                </div>
                <div className="configureFieldRow">
                  <div className="configureFieldCol">
                    <div className="form-btn-container">
                      <Button
                        onClick={() => {
                          setDisabledSaveTime(true);
                          form.resetFields();
                        }}
                        type="button"
                        className="clear-btn"
                        style={{ marginRight: "10px" }}
                      >
                        Cancel{" "}
                      </Button>
                      {disableSaveTime ? (
                        <Button
                          className="saveBtn redBtn"
                          style={{ opacity: "0.5", cursor: "not-allowed" }}
                        >
                          Submit{" "}
                        </Button>
                      ) : (
                        <Button
                          className="saveBtn redBtn"
                          onClick={onFinishRestoreConfig}
                        >
                          Submit
                        </Button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Row
              className="rowBody h-25"
              gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            >
              <Col className="gutter-row tabContent index-tab" span={16}>

              </Col>
            </Row>

          </div>
        </div>
      </div>
    </div>
  );
}
